import "./Navbar.css"

import React, { useState } from 'react'
import { FaBars, FaTimes } from "react-icons/fa"
import { Link } from "react-router-dom"
const Navbar = () => {
    const [show,setShow] = useState(false);
    const clickHandle = ()=>{
        setShow(!show);
    }
    const[color,setColor] = useState(false);
    const changeColor = ()=>{
      if(window.scrollY >= 100){
        setColor(true);
      }else{
        setColor(false);
      }
    }

    window.addEventListener("scroll",changeColor)

  return (
    <div className={color ? "header header-bg": "header"}>
      <Link to="/">
        <h1>Saurabh</h1>
      </Link>
      <ul className={show ? "nav-menu active" : "nav-menu"}>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/project">Project</Link></li>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/contact">Contact</Link></li>
      </ul>
      <div className="hamburger" onClick={clickHandle}>
        {show ? (<FaTimes size={20} style={{color:"#fff"}}/>):(<FaBars size={20} style={{color:"#fff"}}/>)}
        
        
      </div>
    </div>
  )
}

export default Navbar
